var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProhibitedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "prohibited-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.632.75h12v12h-12z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#prohibited-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.745 9.914A5 5 0 0 0 2.71 2.878zM2.003 3.586a5 5 0 0 0 7.036 7.036z"
}))));
export { SvgProhibitedIcon as ReactComponent };
export default __webpack_public_path__ + "e6f490f446deada411897a00396974ab.svg";